"use strict";

module.exports = /* @ngInject */ function($stateProvider, $urlRouterProvider) {
  $urlRouterProvider.otherwise("/");

  $stateProvider
    .state("launch", {
      url: "/launch",
      template: require("views/launch.html")
    })
    .state("error", {
      url: "/error",
      template: require("views/error.html")
    })
    .state("window", {
      url: "/window",
      template: require("views/window.html")
    })
    .state("global-settings", {
      url: "/global-settings",
      template: require("app/ui/globalSettings.html")
    })
    .state("mfa", {
      url: "/mfa",
      template: require("views/mfa.html")
    })
    .state("home", {
      url: "/",
      template: require("views/home.html")
    });
};



// WEBPACK FOOTER //
// ./app/config/routingConfig.js